import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';

export const Container = styled.div`
  position: relative;
  height: 100%;
  flex-direction: column;
  display: flex;
  padding: 100px;
  align-items: center;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 24px;
  max-width: 315px;
  font-family: 'Roboto';
`;

export const Input = styled.input`
  margin-right: 12px;
  padding: 5px 8px;
  width: 250px;

  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;

  background: ${colors.baseBackground};
  border: 1px solid ${colors.lightGray21};
  border-radius: 4px;

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${colors.darkGray14};
  }

  &:focus-visible {
    border: 1px solid lightblue;
    outline: none;
  }
`;

export const SubText = styled.p`
  padding-top: 12px;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  text-align: center;
  color: ${colors.darkGray1};
`;

export const SubmitButton = styled.button`
  border: none;
  padding: 5px 10px;
  background-color: ${colors.blue1};
  color: ${colors.white};
  font-weight: 500;
  border-radius: 3px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  outline: 0;
  float: right;
  opacity: ${(props) => (props.active ? 1 : 0.4)};
  height: 26px;
  font-style: normal;
  font-size: 11px;
  line-height: 16px;

  display: flex;
  align-items: center;
  text-align: center;

  &:hover {
    background-color: ${(props) => (props.active ? `${colors.blue12}` : `${colors.blue1}`)};
  }
`;
